export default {
  data() {
    return {
      snackbar: false,
      snackColor: null,
      snackMessage: '',
      snackTimeout: 0,
    }
  },
  methods: {
    handleNotification(notification) {
      if (notification.message != undefined) {
        this.snackbar = true
        this.snackColor = notification.type || notification.color || 'info'
        this.snackMessage = notification.message
        this.snackTimeout = notification.timeout || 6000
      }
    },
  },

}